import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Per-DEVICE settings — NEVER synced to the server (unlike settingsStore,
// which round-trips through marketdata): these choices depend on the
// form-factor, so an account-level value would make one device clobber the
// others.
export const useDeviceSettingsStore = create(
  persist(
    (set) => ({
      // Navbar chart-config controls (Tipo de gráfico, Cores, Período, Estudos…):
      // true = shown in the navbar (default), false = hidden — the user reaches
      // them via the always-on chart context menu instead.
      // null = user never chose → default (true).
      navbarChartControls: null,
      setNavbarChartControls: (value) => set({ navbarChartControls: value }),
    }),
    {
      name: "tz-device-settings",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

// Reactive: true = navbar shows the chart-config controls (default). Off hides
// them; the unified chart context menu (always on) is the alternative access.
// Independent of the chartContextMenu release flag.
export const useNavbarChartControls = () => {
  const pref = useDeviceSettingsStore((state) => state.navbarChartControls);
  return pref ?? true;
};
